<script setup lang="ts">
defineProps<{ email: string | null }>()
</script>

<template>
    <!-- Breaks a long address after the @ before it breaks inside a word -->
    <strong><template v-for="(part, index) in email?.split('@')" :key="index"><template v-if="index">@<wbr></template>{{ part }}</template></strong>
</template>
